import { COUNTRY_CANADA, COUNTRY_UNITED_STATES } from "../CountrySelect/countries";

// Verbatim HubSpot `state_` picklist values, which cover the US and Canada only.
export const STATE_NOT_APPLICABLE = "N/A";

export const US_STATE_OPTIONS = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington DC",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
] as const;

export const CA_PROVINCE_OPTIONS = [
  "Alberta",
  "British Columbia",
  "Manitoba",
  "New Brunswick",
  "Newfoundland and Labrador",
  "Northwest Territories",
  "Nova Scotia",
  "Nunavut",
  "Ontario",
  "Prince Edward Island",
  "Quebec",
  "Saskatchewan",
  "Yukon",
] as const;

export const STATE_OPTIONS = [STATE_NOT_APPLICABLE, ...US_STATE_OPTIONS, ...CA_PROVINCE_OPTIONS] as const;

export type State = (typeof STATE_OPTIONS)[number];

export function countryHasRegions(country?: string | null): boolean {
  return country === COUNTRY_UNITED_STATES || country === COUNTRY_CANADA;
}

// Everywhere else has no HubSpot options at all, so N/A is the only honest answer.
export function stateOptionsForCountry(country?: string | null): readonly string[] {
  if (country === COUNTRY_UNITED_STATES) return US_STATE_OPTIONS;
  if (country === COUNTRY_CANADA) return CA_PROVINCE_OPTIONS;
  return [STATE_NOT_APPLICABLE];
}

// "State" reads as wrong in Canada and "Province" reads as wrong in the US.
export function stateLabelForCountry(country?: string | null): string {
  if (country === COUNTRY_UNITED_STATES) return "State";
  if (country === COUNTRY_CANADA) return "Province or Territory";
  return "State / Province";
}
